import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import RecoverValueFromSpentCoCatalyst from "./sections/RecoverValueFromSpentCoCatalyst";
import OurPreservationPhilosophy from "./sections/OurPreservationPhilosophy";
import VeteranOwnedDetailOriented from "./sections/VeteranOwnedDetailOriented";
import AdvancedProtectionSystems from "./sections/AdvancedProtectionSystems";
import EcoSealCommitment from "./sections/EcoSealCommitment";
import SuccessStories from "./sections/SuccessStories";
import SecureYourFreeQuote from "./sections/SecureYourFreeQuote";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <RecoverValueFromSpentCoCatalyst />
      <OurPreservationPhilosophy />
      <VeteranOwnedDetailOriented />
      <AdvancedProtectionSystems />
      <EcoSealCommitment />
      <SuccessStories />
      <SecureYourFreeQuote />
      <Footer />
    </div>;
}